import { CartEntryDetails, ListEntry } from '@commerce-cart-webcomponents/sdk';
import { CheckoutCard } from '@commerce-product-webcomponents/ui';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';

export const CheckoutCardForModal = ({
  entry,
  isABO,
  className,
}: {
  entry: CartEntryDetails | ListEntry;
  isABO: boolean;
  className?: string;
}) => {
  const { hideBVFlag = false } = useFeatureFlag();
  return (
    <CheckoutCard
      key={entry.entryId}
      className={className}
      pointValue={isABO ? String(entry.totalPrice?.amwayValue?.pointValue) : ''}
      businessVolume={isABO && !hideBVFlag ? String(entry.totalPrice?.amwayValue?.businessVolume) : ''}
      productPrice={entry.totalPrice?.value}
      productSize=""
      productId={entry.product.id as string}
      productName={entry.product.name as string}
      productQuantity={entry.quantity}
      link={entry.product.cartIconPublicUrl as string}
      alt={entry.product.cartIconPublicUrl as string}
      brandName={entry.product.brand as string}
    />
  );
};
